module.exports = __webpack_public_path__ + "static/media/portfolio2.d70d1c9a.png";